import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AppModeService {
  /**
   * Detects if the application is running in mobile app mode or web browser
   * Returns true if running as a mobile app, false if running in web browser
   *
   * Detection strategies (in order):
   * 1. Check for appMode query parameter: ?appMode=1 or ?appMode=true
   * 2. Check UserAgent for mobile webview indicators:
   *    - 'wv' for Android WebView
   *    - 'android' for Android devices
   *
   * @returns boolean - true if app, false if web
   */
  isApp(): boolean {
    if (typeof window === 'undefined' || typeof navigator === 'undefined') {
      return false;
    }

    // Strategy 1: Check for app mode query parameter
    const params = new URLSearchParams(window.location.search);
    const hasAppQuery =
      params.get('appMode') === '1' || params.get('appMode') === 'true';

    if (hasAppQuery) {
      return true;
    }

    // Strategy 2: Check UserAgent for mobile webview indicators
    const userAgent = navigator.userAgent.toLowerCase();
    const looksLikeMobileWebView =
      userAgent.includes('wv') || // Android WebView
      userAgent.includes('android'); // Android device

    return looksLikeMobileWebView;
  }

  /**
   * Returns the appropriate API path based on app/web mode
   * @returns string - '/api/mobile/' for app, '/api/' for web
   */
  getApiPath(): string {
    return this.isApp() ? '/api/mobile/' : '/api/';
  }

  /**
   * Logs the current mode for debugging purposes
   */
}
